module.exports = "pegasus_template/assets/your-logo-here.png";